import { render, staticRenderFns } from "./IndexWorkspace.vue?vue&type=template&id=42b46c08&scoped=true"
import script from "./IndexWorkspace.vue?vue&type=script&lang=js"
export * from "./IndexWorkspace.vue?vue&type=script&lang=js"
import style0 from "./IndexWorkspace.vue?vue&type=style&index=0&id=42b46c08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b46c08",
  null
  
)

export default component.exports